// react앱 실행 시작점

import React from 'react';
import ReactDOM from 'react-dom'; // 'react-dom/client'에서 변경
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import axios from 'axios';

// 🚩 [최우선] 인앱 브라우저 스크립트 에러 방어막 (모든 로직보다 먼저 실행)
if (typeof window !== 'undefined' && !window.webkit) {
  window.webkit = { messageHandlers: {} };
}

// 백엔드 Render 주소 설정
axios.defaults.baseURL = 'https://the-pivot-logical-battleground.onrender.com';

// React 17 버전 방식의 렌더링 (에러 해결 핵심)
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);